import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

export default function Navbar({ isAuthenticated, userRole, onLogout }) {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    // Close mobile menu when clicking outside
    useEffect(() => {
        const closeMenu = (e) => {
            if (isOpen && !e.target.closest('.navbar-collapse') && !e.target.closest('.navbar-toggler')) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', closeMenu);
        return () => {
            document.removeEventListener('click', closeMenu);
        };
    }, [isOpen]);

    return (
        <nav className={`navbar navbar-expand-lg navbar1 ${scrolled ? 'scrolled' : ''}`}>
            <div className="container navbar1">
                <Link className="navbar-brand" to="/">
                    <b className='fs-3 text-light'>Waghchaure Lawns</b>
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleNavbar}
                    aria-controls="navbarNavAltMarkup"
                    aria-expanded={isOpen ? "true" : "false"}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNavAltMarkup">
                    <div className="navbar-nav animtn ms-auto">
                        <Link className="nav-link nav-content text-light" to="/" onClick={() => setIsOpen(false)}>
                            <span>Home</span>
                        </Link>
                        <Link className="nav-link nav-content text-light" to="/event-gallery" onClick={() => setIsOpen(false)}>
                            <span>Event Gallery</span>
                        </Link>
                        <Link className="nav-link nav-content text-light" to="/contact" onClick={() => setIsOpen(false)}>
                            <span>Contact</span>
                        </Link>
                        <Link className="nav-link nav-content text-light" to="/about" onClick={() => setIsOpen(false)}>
                            <span>About Us</span>
                        </Link>
                        {isAuthenticated ? (
                            <>
                                {userRole === 'ROLE_ADMIN' && (
                                    <Link
                                        className="nav-link nav-content text-light"
                                        to="/admin/AdminDashboard"
                                        onClick={() => setIsOpen(false)}
                                    >
                                        <span>Admin Dashboard</span>
                                    </Link>
                                )}
                                <Link className="nav-link nav-content text-light" to="/my-bookings" onClick={() => setIsOpen(false)}>
                                    <span>My Bookings</span>
                                </Link>
                                <Link
                                    className="nav-link nav-content text-light"
                                    to="/"
                                    onClick={() => {
                                        setIsOpen(false);
                                        onLogout();
                                    }}
                                >
                                    <span>Logout</span>
                                </Link>
                            </>
                        ) : (
                            <Link className="nav-link nav-content text-light" to="/login" onClick={() => setIsOpen(false)}>
                                <span>Login/Register</span>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
}